import {defineStore} from 'pinia'
import api from '@/services/api'

export const useTemplatesStore = defineStore('templates', {
    state: () => ({
        items: undefined
    }),
    getters: {
        pageTemplates: (state) => {
            return state.items?.filter(o => o.type === 'page')
        },
        contentTypes: (state) => {
            return state.items?.filter(o => o.type === 'contentType')
        }
    },
    actions: {
        async init(refresh) {
            if (this.items === undefined || refresh) {
                const o = await api.get('api/component/templates_templates', {
                    params: {sort: 'title'}
                })
                
                this.items = o.data.items
            }
        }
    }
})